import styled from 'styled-components/macro';
import { Typography } from '@redis-ui/components';

export const SocialLoginButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const SocialLoginImage = styled.div`
  margin-bottom: 0.3rem;
  display: flex;
`;

export const SocialLoginName = styled(Typography.Body)`
  color: ${({ theme }) =>
    theme.appComponents.login.components.socialLogin.socialLoginButton.socialLoginName.color};
`;
